// extracted by css-extract-rspack-plugin
export default {"root":"root-v9yjeN","content":"content-JA1PIA","logo":"logo-fYeTqp","copyright":"copyright-w5yFXO text-sm-light","image":"image-VFseNs"};